import { formatBalance } from '@ui/src';
import Card from '../card/card';
import { CurrenciesTypes } from './types';

import cn from './styles.module.css';

const Currencies = ({
  currencies,
  balance,
  isLoading,
  currenciesList,
  dictionariesCurrencies,
}: CurrenciesTypes): React.JSX.Element => {
  const formattedCurrencies = currencies?.map((item) => {
    const balances = balance?.filter((value) => value.currencyId === item);

    let total = 0;

    balances?.forEach((balanceValue) => {
      total += balanceValue.value;
    });

    return {
      balance: total,
      currency: currenciesList?.find((currency) => currency.value === item)
        ?.suffix,
      currencyId: currenciesList?.find((currency) => currency.value === item)
        ?.value,
    };
  });

  return (
    <Card title="Currency balance" isLoading={isLoading} transparent>
      <div className={cn.currenciesWrapper}>
        {formattedCurrencies &&
          formattedCurrencies.map((item) => (
            <div key={item.currency} className={cn.currency}>
              {`${formatBalance(
                item.balance,
                dictionariesCurrencies?.find(
                  (currency) => currency.id === item.currencyId,
                ),
              )} ${item?.currency?.toUpperCase()}`}
            </div>
          ))}
      </div>
    </Card>
  );
};

export default Currencies;
